// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#tblMain[data-v-9a739472]{\r\n  width: 1500px;\n}\n#tblMain2[data-v-9a739472]{\r\n  width: 1500px;\n}\n.btn[data-v-9a739472]{\r\n  color: white !important;\r\n  margin: 5px;\r\n  /*width: px;*/\n}\n.short[data-v-9a739472]{\r\n  width:80px;display: inline;\n}\r\n", ""]);
// Exports
module.exports = exports;
